import type { OptionItem } from 'components/atoms/MultiSelect';
import type { UseLocalization } from 'providers/LocalizationProvider';
import type {
  Activity,
  LegacyActivity,
} from 'services/partnersSelfSignup/activities';

export const normalizeLegacyActivities = (list: LegacyActivity[]): Activity[] =>
  list.map(legacyActivity => ({
    id: legacyActivity.id,
    translationKey: legacyActivity.activity_key,
    defaultValue: '',
    category: {
      id: '',
      translationKey: legacyActivity.category_key,
      defaultValue: '',
    },
  }));

export function normalizeActivities(list: Activity[]): Activity[] {
  const normalizeTranslationKey = (translationKey: string) => {
    return translationKey.replace('partner_activities.', 'partner_activities:');
  };
  return list.map(activity => ({
    ...activity,
    translationKey: normalizeTranslationKey(activity.translationKey),
    category: {
      ...activity.category,
      translationKey: normalizeTranslationKey(activity.category.translationKey),
    },
  }));
}

export const resolveActivitiesOptions = (
  t: UseLocalization['t'],
  activities?: Activity[],
) =>
  activities?.map(activity => ({
    id: activity.id,
    name: t(activity.translationKey, { defaultValue: activity.defaultValue }),
    category: t(activity.category.translationKey, {
      defaultValue: activity.category.defaultValue,
    }),
  })) ?? [];

export const resolveOptionsToActivities = (
  options: OptionItem[],
  activities?: Activity[],
) => {
  const mapOptionsId = options.map(option => option.id);
  return activities?.filter(item => mapOptionsId.includes(item.id)) ?? [];
};
